const digest = '0c3ef6a59c26d6fcd7baa81c4779713360af6a11e845198acaaba815331b60c4';
const css = `._tooltip_1k8yb_1{border-radius:.5rem;top:3.25rem}._tooltipVariant_1k8yb_11,._tooltip_1k8yb_1{max-width:90vw;outline:none;position:absolute;width:20rem;z-index:80}._tooltipVariant_1k8yb_11{border:1px solid #e0e0e0;border-radius:1rem;min-width:326px;top:5.5rem}._tooltipWithError_1k8yb_23{top:7.5rem}@media (max-width:799px){._tooltipVariant_1k8yb_11,._tooltip_1k8yb_1{border-radius:0;bottom:0;left:0!important;max-width:none;position:fixed;right:0;top:0;width:auto;z-index:var(--above_C2C,109000)}}._tooltipBody_1k8yb_51{flex:1;overflow-y:auto}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'tooltip': '_tooltip_1k8yb_1', 'tooltipVariant': '_tooltipVariant_1k8yb_11', 'tooltipWithError': '_tooltipWithError_1k8yb_23', 'tooltipBody': '_tooltipBody_1k8yb_51' };
export const tooltip = '_tooltip_1k8yb_1';
export const tooltipVariant = '_tooltipVariant_1k8yb_11';
export const tooltipWithError = '_tooltipWithError_1k8yb_23';
export const tooltipBody = '_tooltipBody_1k8yb_51';
export { css, digest };